import http from "./httpService";

const getResellerInfo = (machineId) => {
  return http.get(`/machine/reseller/${machineId}/`).then((response) => response.data);
};

const updateResellerInfo = (machineId, resellerId) => {
  const data = { reseller: resellerId };
  return http.put(`/machine/reseller/${machineId}/`, data).then((response) => response.data);
};

const getResellers = () => {
  return http.get("/resellers/").then((response) => response.data);
};

const createCloudInstance = (cloudIdentifier = null) => {
  const data = cloudIdentifier ? { cloud_identifier: JSON.parse(cloudIdentifier) } : {};
  return http.post("/machine/cloud/aws/", data).then((response) => response);
};

const getCloudIdentifiers = () => {
  return http.get("/cloud-identifiers/").then((response) => response.data);
};

export { getResellerInfo, updateResellerInfo, getResellers, createCloudInstance, getCloudIdentifiers };
